export const contest = {
  qjy: 'Перейти к торговле',
  grbm: 'Индивидуальная регистрация',
  qdl: 'Войти',
  bsyjs: 'Соревнование завершено',
  bsjs: 'Соревнование окончено',
  djs: 'До начала соревнования по симуляционной торговле {v1} (обратный отсчёт)',
  days: 'дн.',
  hours: 'ч',
  minutes: 'мин',
  seconds: 'сек',
  ljyq: 'Пригласить сейчас',
  tdbm: 'Командная регистрация',
  qzc: 'Зарегистрироваться',
  qrsfgrbm: 'Подтвердить индивидуальную регистрацию?',
  qxbm: 'Отменить регистрацию',
  qrbm: 'Подтвердить регистрацию',
  gxnbmcg: 'Поздравляем! Вы успешно зарегистрировались и получили 100 000 USDT виртуальных средств.',
  xzjs: 'Выберите вашу роль',
  cwty: 'Стать участником команды',
  cwtz: 'Стать капитаном',
  cjtd: 'Создать команду',
  jtgz: 'Правила создания команды:',
  jtgz1: '1. Если в течение 24 часов после создания в команде менее 5 человек, она будет автоматически расформирована, а участники переведены в личный зачёт.',
  jtgz2: '2. В ожидании формирования команды нельзя участвовать в индивидуальном зачёте.',
  jtgz3: '3. После успешного формирования команды вы не сможете присоединиться к другой команде или участвовать в индивидуальном зачёте.',
  tdmc: 'Название команды:',
  tdjj: 'Описание команды:',
  ljjt: 'Создать команду',
  tdmcbt: 'Введите название команды',
  tdjzbt: 'Введите описание команды',
  cjzdcg: 'Команда успешно создана!',
  xzjrtd: 'Выберите команду для вступления',
  sstdmc: 'Поиск по названию команды',
  dqzdsl: 'Команд на данный момент: {v1}. Выберите команду для вступления.',
  ddtdrs: 'Текущий состав команды: {v1} чел.',
  tdrs: 'Количество участников:',
  tzmc: 'Капитан:',
  jrtd: 'Вступить в команду',
  jrzdcg: 'Вы успешно вступили в команду!',
  grfxlj: 'Ваша реферальная ссылка:',
  grtjm: 'Ваш реферальный код:',
  tdfxlj: 'Ссылка для приглашения в команду:',
  tdtjm: 'Реферальный код команды:',
  tdtzm: 'Имя капитана команды:',
  bctp: 'Сохранить изображение',
  total: 'Всего {v1} записей',
  dd: 'Перейти к',
  qd: 'Подтвердить',
  cyyj: 'Участие гарантирует награду',
  jcdnn: 'Призовой фонд в USDT ждёт вас!',
  jzcj: 'Пожертвуйте прибыль и участвуйте в розыгрыше',
  dqjc: 'Текущий призовой фонд:',
  qjz: 'Пожертвовать',
  jzsm: 'Информация о пожертвованиях',
  kjz: 'Вы можете пожертвовать {v1} USDT. Подтвердить пожертвование?',
  qxjz: 'Отменить пожертвование',
  qrjz: 'Подтвердить пожертвование',
  jzcg: 'Поздравляем, пожертвование успешно выполнено!',
  mnpjyds: 'Соревнование по симуляционной торговле',
  bm: 'Регистрация:',
  bs: 'Соревнование:',
  hyspjyds: 'Фьючерсный турнир ',
  xhspjyds: 'Спот-турнир',
  bmz: 'Регистрация открыта',
  jqqd: 'Следите за обновлениями',
  bsz: 'Идёт соревнование',
  yjs: 'Завершено',
  myptts: 'Командный симуляционный турнир ',
  mypzmxs: 'Еженедельный турнир звёзд',
  mypgrs: 'Индивидуальный симуляционный турнир',
  hyjyds: 'Фьючерсный турнир ',
  xhjyds: 'Спот-турнир',
  my: 'Мои данные',
  pm: 'Рейтинг',
  dync: 'Ник участника',
  dm: 'Название команды',
  zdrs: 'Размер команды',
  nc: 'Ник',
  ljzjy: 'Общий объём торгов',
  ljzjye: 'Общий объём торгов',
  ljzyll: 'Общая доходность',
  zyll: 'Общая доходность',
  zdjl: 'Награда команде',
  mypbsjl: 'Приз за участие',
  myphycs: 'Участвуйте в симуляционном фьючерсном турнире',
  myhyj: 'При регистрации вы получаете 100 000 USDT виртуальных средств для фьючерсов',
  ljbm: 'Участвовать сейчас',
  tzjl: 'Бонус за создание команды',
  ztcg: 'Минимум 5 человек в команде, максимум — 200',
  bwzbhl: 'Капитан,成功创建 команды, получает 100 000 USDT+',
  yqjl: 'Бонус за приглашения',
  yqhycybs: 'Капитан может получить до 100 000 USDT за приглашения',
  hzhyj: 'Участник команды может получить до 50 000 USDT за приглашения',
  mnttbssm: 'Правила командного симуляционного турнира',
  // Командный турнир: правила
  csxq: 'Детали участия:',
  csxq1: '1. В период от начала регистрации до окончания турнира пользователи (после верификации) могут создавать команды. Для участия в командном фьючерсном турнире необходимо наличие от 5 до 200 человек. Если в течение 24 часов после создания в команде менее 5 человек, она расформировывается, а участники автоматически переводятся в личный зачёт.',
  csxq2: '2. Пользователь может присоединиться только к одной команде, повторное участие в другом турнире или одновременное участие в командном и личном зачётах невозможны. Добровольный выход из команды запрещён.',
  ssgz: 'Правила турнира:',
  ssgz1: '1. Бонус капитана: 1) За каждого приглашённого участника капитан получает 1 000 USDT виртуальных средств. Максимальный бонус за приглашения — 100 000 USDT.',
  ssgz1_2: '          2) Если капитан пригласит более 20 друзей, которые начнут торговать, он получит эксклюзивный мерч от Biking.',
  ssgz2: '2. Бонус участника: за каждого приглашённого друга участник получает 500 USDT виртуальных фьючерсных средств. Максимальный бонус — 50 000 USDT.',
  ssgz3: '3. После завершения турнира платформа ранжирует команды по общему объёму торгов.',
  ssgz4: '4. Общий объём торгов командного турнира обновляется ежедневно в 00:00.',
  ssgz5: '5. Для обеспечения честности накрутка объёмов запрещена. При обнаружении накрутки команда поддержки Biking проведёт расследование. Общий объём торгов обновляется ежедневно в 00:00.',
  ssgz6: '6. За подробными правилами обращайтесь в команду поддержки Biking.',
  jlfp: 'Распределение наград:',
  jlfp1: '1. Распределение USDT: (Награда выдаётся в соотношении 90% виртуальных фьючерсных средств и 10% реальных USDT)',
  jlfp1_1: '1) Распределение внутри команды:',
  jlfp1_2: 'Капитан получает = (Личный объём торгов капитана / Общий объём командного турнира Biking) * 5 000 000 USDT',
  jlfp1_3: '+ (Суммарный объём торгов остальных участников / Общий объём командного турнира) * 20% * 5 000 000 USDT.',
  jlfp1_4: 'Участник команды получает = (Собственный объём торгов / Общий объём командного турнира) * 80% * 5 000 000 USDT.',
  jlfp1_5: '2) Команды с выдающимися результатами получают бонус к доходности! За каждое удвоение числа участников или объёма торгов бонусная доходность увеличивается на 50%.',
  myptdjyze: 'Общий объём торгов командного симуляционного турнира',
  myptdphb: 'Командный рейтинг симуляционного турнира',
  tdsl: 'Команд на данный момент: {v1}. Выберите команду для вступления.',
  tznc: 'Ник капитана:',
  tdjs: 'Описание команды:',
  // Еженедельный турнир звёзд: правила
  mypzmxgzsm: 'Правила еженедельного симуляционного турнира звёзд',
  zmxphb: 'Еженедельный командный рейтинг звёзд (только топ-3)',
  zmxtdphb: 'Еженедельный командный рейтинг звёзд',
  bdxq: 'Детали рейтинга:',
  bdxq1: '1. Создание команды и начало торгов означает автоматическое участие в еженедельном рейтинге команд звёзд.',
  zmxgz: '1. Каждую календарную неделю система ранжирует команды по общему объёму торгов и публикует «Еженедельный рейтинг команд звёзд». Топ-3 команды делят между собой 2 000 000 USDT виртуальных фьючерсных средств.',
  zmxgz1: '2. Рейтинг обновляется каждую среду в 14:00.',
  bddym: '1-е место: 1 000 000 USDT виртуальных средств;',
  dbdem: '2-е место: 600 000 USDT;',
  bddsm: '3-е место: 400 000 USDT.',
  tdnbfpgz: 'Распределение внутри команды:',
  tzx: 'Капитану: 20%;',
  nbyjpm: 'Топ-10 участников (кроме капитана): 40%;',
  syty: 'Остальные участники: 40%.',
  // Индивидуальный турнир: правила
  mypgrsgzsm: 'Правила индивидуального симуляционного турнира',
  mypgrphb: 'Индивидуальный рейтинг симуляционного турнира',
  bsxz: 'Условия участия:',
  bsxz1: '1. Каждый новый пользователь при регистрации получает 100 000 USDT виртуальных фьючерсных средств.',
  bsxz2: '2. Существующий пользователь при регистрации получает 50 000 USDT виртуальных средств.',
  bsxz3: '2. Во время турнира пользователи могут получать дополнительные виртуальные средства, приглашая друзей:',
  bsxz4: '1) За каждого приглашённого друга — 2 000 USDT виртуальных средств.',
  bsxz6: '2) Максимальный бонус за приглашения — 50 000 USDT.',
  bsxz7: '3. Участие разрешено только верифицированным пользователям Biking.',
  bsxz8: '4. После завершения турнира ранжирование в личном зачёте проводится по общему объёму торгов.',
  grgzsm1: '1. Общий призовой фонд: 2 000 000 USDT + 30 наборов мерча.',
  grgzsm2: '2. Детали распределения:',
  grgzsm3: '1-е место: 800 000 USDT + 5 наборов мерча',
  grgzsm4: '2-е место: 500 000 USDT + 5 наборов мерча',
  grgzsm5: '3-е место: 200 000 USDT + 3 набора мерча',
  grgzsm6: '4–20 места: делят 500 000 USDT + 17 наборов мерча',
  hyjybs: 'Фьючерсный турнир',
  hyjybsgzsm: 'Правила фьючерсного турнира',
  hyspgrphb: 'Индивидуальный рейтинг фьючерсного турнира',
  csxz: 'Условия участия:',
  hybsgz1: '1. При регистрации вы получаете фьючерсный бонус 100 USDT (использование по правилам платформы). Прибыль от бонуса не учитывается в общей доходности.',
  hybsgz2: '2. Приглашайте друзей: за каждого приглашённого — 20 USDT фьючерсного бонуса. Максимум 100 USDT.',
  hybsgz3: '3. Участие только для верифицированных пользователей.',
  hybsgz4: '4. Рейтинг определяется по общей доходности за период турнира.',
  jcfp: 'Распределение фонда:',
  jcfp1: 'Общий фонд: 2 000 000 USDT + 30 наборов мерча',
  fpgz: 'Правила распределения:',
  fpgzs: '(Награда выдаётся в соотношении 90% фьючерсного бонуса и 10% реальных USDT)',
  fpgz1: '1-е место: 800 000 USDT + 5 наборов мерча',
  fpgz2: '2-е место: 500 000 USDT + 5 наборов мерча',
  fpgz3: '3-е место: 200 000 USD + 3 набора мерча',
  fpgz4: '4–20 места: делят 500 000 USDT + 17 наборов мерча',
  hjyq: 'Условия получения награды',
  hjyq1: '1. Прибыль в фьючерсном турнире = Итоговая стоимость портфеля (включая нереализованную прибыль) − Начальная стоимость портфеля (включая нереализованную прибыль) − Фьючерсный бонус.',
  hjyq2: '2. При одинаковой прибыли побеждает пользователь с большим объёмом торгов.',
  hjyq3: '3. Призёры должны иметь положительную прибыль.',
  // Пожертвования
  gyc1: 'Этот фонд открыт только для участников фьючерсного и спот-турниров. Вы можете досрочно завершить участие и «пожертвовать» свой объём торгов или доходность в благотворительный фонд.',
  gyc2: 'Система добавляет в фонд 0,5 USDT за каждый процент доходности. Сумма отображается на странице турнира.',
  gyc3: 'Пример: если у пользователя A доходность 38%, система добавит 38 × 0,5 = 19 USDT в фонд.',
  gyc4: 'Максимальная сумма фонда: 50 000 USDT (фьючерсный бонус).',
  gyc5: 'При пожертвовании объёма торгов: 0,5 USDT за каждые 100 USDT объёма. Пример: объём 1000 USDT → 0,5×10 = 5 USDT.',
  gyc7: 'Правила пожертвований: каждый пользователь может сделать пожертвование только один раз. После пожертвования вы теряете право на участие в рейтинге, получение наград и дальнейшее участие в турнирах Biking (включая спот-турнир, если вы участвовали в фьючерсном).',
  gyc8: 'После турнира фонд разыгрывается в трёх раундах: каждый раунд — 10 победителей поровну. Распределение: 40%, 30%, 30%.',
  gyc9: 'Время розыгрыша: случайно в течение 7 рабочих дней после турнира. Уточняйте у поддержки.',
  xhjybs: 'Спот-турнир',
  xhjybsgzsm: 'Правила спот-турнира',
  xhjydsphb: 'Рейтинг спот-турнира',
  grbmcg: 'Индивидуальная регистрация успешна!',
  // Спот-турнир правила
  xhgz1: '1. В турнире участвуют все спот-пары платформы.',
  xhgz2: '2. Баланс спот-счёта участника должен быть > 50 USDT.',
  xhgz3: '3. Рейтинг определяется по общему объёму спот-торгов.',
  jjfp: 'Распределение призов',
  zjc: 'Общий фонд: 1 000 000 USDT + 20 наборов мерча',
  xhdym: '1-е место: 400 000 USDT + 10 наборов мерча',
  xhdem: '2-е место: 200 000 USDT + 5 наборов мерча',
  xhdsm: '3-е место: 100 000 USDT + 5 наборов мерча',
  xhdsm1: '4–20 места: делят 300 000 USDT',
  mypdnpm: 'Внутрикомандный рейтинг симуляционного турнира',
  yqjl1: 'Бонус за приглашения',
  wdjye: 'Мой объём торгов:',
  wdzsyl: 'Моя общая доходность:',
  grzjyl: 'Общий объём торгов (индивидуальный):',
  grzsyl: 'Общая доходность (индивидуальная):',
  sqzjye: 'Общий объём торгов в турнире:',
  zjye: 'Общий объём торгов:',
  bsyqrs: 'Приглашено:',
  ren: 'чел.',
  hdmnj: 'Получено виртуальных средств:',
  hdzj: 'Получено бонусов:',
  hyjyxq: 'Детали фьючерсного турнира',
  xhjyxq: 'Детали спот-турнира',
  hy: 'Фьючерсы',
  xh: 'Спот',
  jlsm: 'Пояснение к наградам',
  jlsm1: '1. Во время турнира верифицированные пользователи могут создавать команды от 5 до 200 человек. Если через 24 часа после создания менее 5 человек, команда расформировывается.',
  jlsm2: '2. Каждый может быть только в одной команде, добровольный выход невозможен.',
  tdjye: 'Объём торгов команды:',
  wdjs: 'Моя роль:',
  dz: 'Капитан',
  dy: 'Участник',
  tdzyll: 'Общая доходность команды:',
  wdzyll: 'Моя общая доходность:',
  tdyjhdjl: 'Предполагаемая награда команды:',
  tdjs1: 'Описание команды',
  grxq: 'Детали участника',
  tdxq: 'Детали команды',
  tdjylpm: 'Рейтинг команд по объёму торгов:',
  tdzsyl: 'Общая доходность команды',
  tdnphb: 'Внутрикомандный рейтинг',
  tcsybs: 'Совет: после пожертвования вы выбываете из всех турниров.',
  zwcjhybs: 'Вы ещё не участвуете в симуляционном фьючерсном турнире',
  zwsj: 'Нет данных',
  tdmcbzq: 'Некорректное название команды',
  tdjjbzq: 'Некорректное описание команды',
  hdjxz_contract: 'Битва фьючерсных турниров в самом разгаре! Участвуйте и делите фонд 2 000 000 USDT, выигрывайте эксклюзивный мерч Biking.',
  hdjxz_spot: 'Спот-турнир в самом разгаре! Участвуйте и делите фонд 1 000 000 USDT, выигрывайте эксклюзивный мерч Biking.',
  hdjs: 'Следите за следующим турниром!',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/ru.js